import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';
import React from 'react';
import { sanityConfig } from '../../../sanity-config';

const PortableTextWithHighlightDecoratorComponents = {
  types: {
    imageWithAlt: ({ value }) => (
      <GatsbyImage
        alt={value.alt}
        style={{ margin: '1rem 0' }}
        image={getGatsbyImageData(value.image.asset._ref, { height: 65 }, sanityConfig)}
      />
    ),
  },
  marks: {
    highlighted: ({ children }) => <span className="highlight-decorator">{children}</span>,
  },
};

export const PortableTextWithHighlightDecorator = ({ content }) => (
  <PortableText value={content} components={PortableTextWithHighlightDecoratorComponents} />
);
